import { Subject } from 'rxjs'

import Constants from '../Constants';
import { removeLocalStorageItems, setLocalStorageItem } from '../utils/localStorageUtil';

// keys cleared on logout — every new auth/session key should be added here
const SESSION_STORAGE_KEYS = [
    'authtoken',
    'casepeer_redirect_url',
    'casepeer_pkce_code_verifier',
];

export default class AuthService {

    static LoggedInUserDetails = new Subject();

    static UpdateLoggedInUserDetails = (data) => {
        this.LoggedInUserDetails.next(data);
    }

    static GetLoggedInUserData = () => {
        const {token,isToken} = Constants.getAuthtoken();
        if(!isToken){return false}
        const parts = token.split('.');
        const payload = JSON.parse(window.atob(parts[1]));
        return payload;
    }

    static clearSession = () => {
        removeLocalStorageItems(SESSION_STORAGE_KEYS);
    }

    static UpdateLoggedInUserSession = (token) => {
        setLocalStorageItem("authtoken", token);
        const updatedUserData = this.GetLoggedInUserData();
        this.UpdateLoggedInUserDetails(updatedUserData);
    }

}